import { useTranslation } from "react-i18next";
import { getDaysLeft } from "../../utils/getInsuranceDaysLeft";
import { CarHealthGauge } from "./CarHealthGuage";
import { calculateCarHealth } from "../../utils/carHealthCalculator";
import { Car } from "../../types/car.types";

export const ShowCar = ({
  selectedCar,
  handleUpdateKms,
}: {
  selectedCar: Car;
  handleUpdateKms: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="mb-6 w-full mt-4 p-6 bg-popupLight dark:bg-popupDark text-primaryText dark:text-primaryTextDark rounded-xl shadow-lg">
        <h3 className="text-lg font-semibold mb-2">
          {selectedCar.brand} {selectedCar.model} ({selectedCar.number}) -{" "}
          {selectedCar.carType}
        </h3>

        <div className="p-4 flex flex-col md:flex-row items-center md:items-start gap-4">
          <div className="flex-shrink-0 w-full md:w-2/5 flex justify-center">
            <CarHealthGauge value={calculateCarHealth(selectedCar)} />
          </div>

          <div className="flex-1 w-full md:w-3/5 flex flex-col">
            <div className="grid grid-cols-2 gap-4 text-base font-bold">
              <div>
                <span className="font-medium">{t("KMs Clocked:")} </span>
                {selectedCar.kms || "N/A"}
              </div>
              <div>
                <span className="font-medium">{t("Last Service:")} </span>
                {selectedCar.lastServiceDate
                  ? (selectedCar.lastServiceDate as any).slice(0, 10)
                  : "N/A"}
              </div>
              <div>
                <span className="font-medium">{t("Service KMs:")} </span>
                {selectedCar.lastServiceKms || "N/A"}
              </div>
              <div>
                <span className="font-medium">{t("Driving Frequency:")} </span>
                {selectedCar.driveFrequency || "N/A"}
              </div>{" "}
              <div className="col-span-2 flex items-center gap-3 mt-1">
                <button
                  onClick={handleUpdateKms}
                  className="px-3 py-1 bg-secondaryText dark:bg-secondaryTextDark text-primaryText text-sm font-medium rounded"
                >
                  {t("Change KMS")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full mb-6 mt-4 p-6 bg-popupLight dark:bg-popupDark text-primaryText dark:text-primaryTextDark rounded-xl shadow-lg">
        <h3 className="text-lg font-semibold mb-5">{t("Car Details")}</h3>

        <div className="grid grid-cols-2 gap-4 text-base font-bold">
          <div>
            <span className="font-medium">{t("Car Number") + ":"} </span>
            {selectedCar.number}
          </div>
          <div>
            <span className="font-medium">{t("Year") + ":"} </span>
            {selectedCar.year}
          </div>
          <div>
            <span className="font-medium">{t("Brand") + ":"} </span>
            {selectedCar.brand}
          </div>
          <div>
            <span className="font-medium">{t("Model") + ":"} </span>
            {selectedCar.model}
          </div>
          <div>
            <span className="font-medium">
              {t("KMs driven after last service") + ":"}{" "}
            </span>
            {Number(selectedCar.kms) -
              Number(selectedCar.lastServiceKms) +
              " kms"}
          </div>
        </div>
      </div>

      <div className="w-full mt-4 p-6 bg-popupLight dark:bg-popupDark text-primaryText dark:text-primaryTextDark rounded-xl shadow-lg">
        <h3 className="text-lg font-semibold mb-5">{t("Insurance Details")}</h3>

        <div className="grid grid-cols-2 gap-4 text-base font-bold">
          <div>
            <span className="font-medium">
              {t("Insurance Expiry Date") + ":"}
            </span>{" "}
            {(selectedCar.insuranceExpiry as any)?.slice(0, 10) || "N/A"}
          </div>

          <div>
            <span className="font-medium">
              {t("Your Insurance expires in") + ":"}
            </span>{" "}
            {getDaysLeft(selectedCar.insuranceExpiry as string) + " days"}
          </div>

          <div>
            <span className="font-medium">{t("Insurance Company") + ":"}</span>{" "}
            {selectedCar.insuranceCompany || "N/A"}
          </div>

          <div>
            <span className="font-medium">{t("Insurance Type") + ":"}</span>{" "}
            {selectedCar.insuranceType || "N/A"}
          </div>

          <div>
            <span className="font-medium">{t("Insurance Number") + ":"}</span>{" "}
            {selectedCar.insuranceNumber || "N/A"}
          </div>
        </div>
      </div>
    </>
  );
};
